// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1GlZq","modalForm":"UpgradeEpcsModal_modalForm__1b2CR","modalFooter":"UpgradeEpcsModal_modalFooter__2BKvi"};